import React, { useState, useEffect } from 'react'
import { Link, graphql, navigate } from 'gatsby'
import { getRandomPhrase } from '../data/characters'
import HanziWriter from 'hanzi-writer'
import DefaultLayout from '../components/layout'
import SEO from '../components/seo'
import styled from 'styled-components'
import { speech } from '../utils/utils'
import { AiFillSound } from '@react-icons/all-files/ai/AiFillSound'
import { IoMdArrowBack } from '@react-icons/all-files/io/IoMdArrowBack'

const FlexContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  .gutter {
    width: 93.4vw;
    height: 60px;
    background-color: grey;
    z-index: 1000;
  }
`
const Actions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
`

const PhrasePage = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  let randomPhrase = getRandomPhrase()
  const [phrase, setPhrase] = useState(randomPhrase)

  function updatePhrase() {
    let randomPhrase = getRandomPhrase()
    setPhrase(randomPhrase)
  }
  function printStrokePoints(data) {
    var pointStrs = data.drawnPath.points.map(
      (point) => `{x: ${point.x}, y: ${point.y}}`
    )
  }
  function listenQuestion() {
    speech(phrase.join(''))
  }
  function updateCharacter(phrase) {
    //document.querySelector('#target').innerHTML = ''
    let writers = []
    phrase.map((char, index) => {
      document.querySelector(`#character-target-${index}`).innerHTML = ''
      let writer = HanziWriter.create(`character-target-${index}`, char, {
        width: 350,
        height: 400,
        renderer: 'svg',
        radicalColor: '#166E16',
        onCorrectStroke: printStrokePoints,
        onMistake: printStrokePoints,
        showCharacter: false,
        showHintAfterMisses: 1,
        highlightOnComplete: true,
      })
      writers.push(writer)
    })

    window.writers = writers
  }

  function animate() {
    writers.map((writer, index) => {
      writer.hideCharacter()
    })
    const delay = (writer) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(writer.animateCharacter())
        }, 1000)
      })
    }
    const doNextPromise = (d) => {
      delay(writers[d]).then((x) => {
        d++
        if (d < writers.length) doNextPromise(d)
      })
    }
    doNextPromise(0)
  }

  function quiz() {
    writers.map((writer) => {
      writer.quiz()
    })
  }

  useEffect(() => {
    updateCharacter(phrase)
    speech(phrase.join(''))
  }, [phrase])

  return (
    <DefaultLayout>
      <SEO
        title={siteTitle}
        keywords={[
          `chinese character learning`,
          `game`,
          `poem`,
          `children story`,
        ]}
      />
      <div className="content-box clearfix">
        <FlexContainer>
          {phrase.map((char, index) => (
            <div className="charContainer">
              <div
                id={`character-target-${index}`}
                key={index}
                data-char={char}
              ></div>
              <div className="gutter"></div>
            </div>
          ))}
        </FlexContainer>
        <Actions className="actions">
          <button onClick={listenQuestion}>
            听题 &nbsp;
            <AiFillSound />
          </button>
          <button className="" onClick={updatePhrase}>
            换一题
          </button>
          <button className="" onClick={animate}>
            动画演示
          </button>
          <button className="" onClick={quiz}>
            自我测试
          </button>
          <button onClick={() => navigate(-1)}>
            回退 <IoMdArrowBack />
          </button>
        </Actions>
      </div>
    </DefaultLayout>
  )
}

export default PhrasePage

export const pageQuery = graphql`
  query phrasePageQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`
